import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { SharedModule } from '../shared/shared.module';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // { path: 'change-password', component: ChangePasswordComponent}
]

@NgModule({
  declarations: [  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    // SharedModule
  ],
  exports: [
    
  ]
})
export class AuthenticationModule { }
